var map = {
	"./cricket_summaryLive.json": 768,
	"./cricket_summaryLive2.json": 769
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 767;



//////////////////
// WEBPACK FOOTER
// ../mock-data ^\.\/.*$
// module id = 767
// module chunks = 0